export const ORDER_TYPE_REF = {
	DELIVERY: 'DELIVERY',
	TAKEOUT: 'TAKEOUT',
} as const
